import React from 'react';
import * as css from './GeneratorTypingIndicator.css';

function GeneratorTypingIndicator() {
    return (
        <css.typingBubble role="status" data-testid="ai-message-generator-typing">
            <css.typingDot aria-hidden="true" />
            <css.typingDot aria-hidden="true" />
            <css.typingDot aria-hidden="true" />
        </css.typingBubble>
    );
}

export default GeneratorTypingIndicator;
